import agendaApiConfig from "./agendaApiConfig";

const SpecialityService = {
    async getAll (modalidad) {
        let query =  {}; 
        if(process.env.REACT_APP_SERVICIO == ""){
            query = null;
        }else{
            query =  {ser_codigo : process.env.REACT_APP_SERVICIO, tipo: modalidad }; 
        }
        return await agendaApiConfig.get("/especialidad", {
            params: {
                ...query
            }
        });
    },
    async getByService (codeService, modalidad) {
        let query =  {}; 
        query =  {SER_CODIGO : codeService, tipo: modalidad }; 
        return await agendaApiConfig.get("/especialidad", {
            params: {
                ...query
            }
        });
    },    
    async getProfessionals(codeSpeciality = 0, modalidad) {
        //return await agendaApiConfig.get(`/especialidad/${codeSpeciality}/profesionales`);
        let query =  {}; 
        if(process.env.REACT_APP_SERVICIO == ""){
            query = null;
        }else{
            query =  {SER_CODIGO : process.env.REACT_APP_SERVICIO, tipo: modalidad}; 
        }
        return await agendaApiConfig.get(`/especialidad/${codeSpeciality}/profesionales`, {
            params: {
                ...query
            }
        });
    },
    async getProfessionalsByService(codeSpeciality = 0, codeService, modalidad) {
        //return await agendaApiConfig.get(`/especialidad/${codeSpeciality}/profesionales`);
        let query =  {}; 
        if(codeService == null){
            query =  {SER_CODIGO : process.env.REACT_APP_SERVICIO, tipo: modalidad };             
        }else{
            //query = null;
            query =  {SER_CODIGO : codeService, tipo: modalidad }; 
        }
        //query =  {SER_CODIGO : codeService };
        return await agendaApiConfig.get(`/especialidad/${codeSpeciality}/profesionales`, {
            params: {
                ...query
            }
        });
    }    
}

export default SpecialityService;